module.exports = __webpack_public_path__ + "static/lightBulbManWoman-c7ea5181e88062481da0d1806190bafe.png";